export const SESSION_TOKEN_HEADER = "sessionToken";

const SESSION_LOGIN_EXPIRED_ERROR_CODES = {
	sessionLimitExpired: "E_SESSION_LOGIN_SESSIONLIMITEXPIRED",
	dailySessionLimitExpired: "E_SESSION_LOGIN_DAILYSESSIONLIMITEXPIRED",
	weeklySessionLimitExpired: "E_SESSION_LOGIN_WEEKLYSESSIONLIMITEXPIRED",
	monthlySessionLimitExpired: "E_SESSION_LOGIN_MONTHLYSESSIONLIMITEXPIRED",
};

export const SESSION_LOGIN_EXPIRED_CODES = [
	SESSION_LOGIN_EXPIRED_ERROR_CODES.sessionLimitExpired,
	SESSION_LOGIN_EXPIRED_ERROR_CODES.dailySessionLimitExpired,
	SESSION_LOGIN_EXPIRED_ERROR_CODES.weeklySessionLimitExpired,
	SESSION_LOGIN_EXPIRED_ERROR_CODES.monthlySessionLimitExpired,
];

export const DEVICE_TOKEN_HEADER_KEY = "X-Obg-Device-Token";
export const LOGIN_DISALLOWED_POKER_KEY = "poker_disallowed_countries";

export interface LoginDisallowedFeatureFlag {
	enabled: boolean;
}
